export const createCustomerMutation = `
    mutation createCustomer($input: CreateCustomerInput!) {
        createCustomer(input: $input) {
            id
            name
            status
            contactInfo {
                email
                phone
                website
            }
        }
    }
`;

export const updateCustomerMutation = `
    mutation updateCustomer($input: UpdateCustomerInput!) {
        updateCustomer(input: $input) {
            id
            name
            status
            contactInfo {
                email
                phone
                website
            }
        }
    }
`;

// FNP-717: server-side self-service billing-customer provisioning. Takes NO input —
// billing-api derives the calling account from the Cognito token `account` claim,
// creates-or-returns the Customer owned by that account, AND performs the single-writer
// account->customer link cross-account (setAccountCustomerId). Replaces the broken
// client-orchestrated createCustomer + updateAccount(customerId) flow: the browser no
// longer writes the linkage (FNP-490 single-writer). Idempotent + safe to retry.
export const provisionBillingCustomerForCurrentAccountMutation = `
    mutation provisionBillingCustomerForCurrentAccount {
        provisionBillingCustomerForCurrentAccount {
            id
            name
            status
            ownerAccountId
            contactInfo {
                email
            }
        }
    }
`;
